import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copyable"
export default class extends Controller {
  static targets = [ "copyable", "icon" ]

  connect() {
  }

  copy() {
    var val = this.copyableTarget.textContent.trim()
    if (navigator.clipboard) {
      navigator.clipboard.writeText(val)
    }

    if (this.hasIconTarget) {
      // look for the "data-complete-icon-path" attribute on this element.
      // if it exists, swap this element's source with that path.
      var completePath = this.iconTarget.dataset.completeIconPath
      if (completePath) {
        this.iconTarget.src = completePath
      }
    }
  }
}
